import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_e025dncg: FaireBrandEntity = {
  token: "b_e025dncg",
  type: "brand",
  name: "AMINNAH",
  avatarUrl:
    "https://cdn.faire.com/fastly/c63cae088706166a97d4019e729675b1e2695faaa41ecb6771a3c0c30601dcb3.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/eb6635c67348789a43406d921bbf3d58ef1b219b91e741a5af4b9acda9fa2876.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c63cae088706166a97d4019e729675b1e2695faaa41ecb6771a3c0c30601dcb3.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/eb6635c67348789a43406d921bbf3d58ef1b219b91e741a5af4b9acda9fa2876.jpeg",
  location: "Tampa , FL, USA",
  minimumOrderDollars: 50,
  rating: 4.7,
  reviewCount: 154,
  isInsider: true,
  description:
    '\nHello there! Welcome to AMINNAH. We create handmade vegan-friendly and all-natural skincare products (i.e., body butter, sugar polish, whipped soap, body oil & more. We started in 2016, making fun natural Skin and Body Care. Located in Tampa, FL. Created by a mother of 6 children that hopes to empower other moms to be confident in themselves and their goals/dreams. To believe in being successful and at the same time caring of their family. Who says skincare can\'t be fun!! ❤️\n\nP.S.: All of our products are made of all-natural ingredients, vegan, cruelty-free, hand-made, GMO free, paraben & sulfate free. \nIF INTERESTED IN NO LABEL please use the "UNLABELED" option on the individually listed items.',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:41.272Z",
    importedBy: "entity-db-cli",
  },
};
